import Modal from "@/components/Modal";
import {Module} from "@/common/module/module";
import {BASE_FIELD_ENUM} from "@/common/field/field";
import {BASE_Slot} from "@/common/slot/slot";
import {autoOnePage2, autoOnePageLevels} from "@/const/config";

const initState = {
    resume: null,
    resumeData: null,
    template: null,
    version: {
        current: null
    },
    focus: {
        moduleId: null,
        moduleContentIndex: null,
        filedId: null
    },
    loading: false,
    hover: {
        moduleId: null
    },
    pagination: {
        pageCount:undefined,
        openAutoOnePage: false,
        openAutoPagination: true,
        openHintPagination: false,
        hintPaginationLineVisible: false,
        // onePageLevel: autoOnePageLevels.autoOnePage1,
        onePageLevel: null,
        offsets: null
    },
    interview: {
        list: [],
        jdList: [],
        jdListWithResume: [],
        selectJdId: '',
        isContentModified: false
    },
    aiDecision: [],
    theme: null
};
export default initState;
